
import { Restaurant, MenuItem } from './types';

export const RESTAURANTS: Restaurant[] = [
  {
    id: 'mcdonalds',
    name: "McDonald's",
    category: "Hamburguesas • Americana • $$",
    rating: 4.5,
    deliveryTime: "15-25 min",
    deliveryFee: 25.0,
    image: "https://lh3.googleusercontent.com/aida-public/AB6AXuAZJp-eXBU3Susd8nlKA-PuqFLD8LPif5fqKlwg15Sxe_90hAFKROxO-8fSfiC-rzTnK9hDY0e9K7577UClZZDdhyE7CfaSV-B9N7EMLP1zn3u0sD_DWaZYkuhEYZUlGj03ClE7GuvVbZmvtJMoahfxENTgbQbvhwwC5lXEXlsSVFb9A3a9K22_n2444DBjnvAVHwqgHCCi51Jz-4-p026_sX1mGtvgcpuONgfv3cR6ifPb477k9hxf1qcC5IY1tEps9Ok3MZpcRMA",
    logo: "https://picsum.photos/id/1/100/100",
    banner: "https://lh3.googleusercontent.com/aida-public/AB6AXuCw0d217zZPFXx4yFA65RgOFUB-i_RlvaGXSiQTI2sYABPD43Wf0nR7Nn17OaOGHp5ydqPd7Nj-dAeQz0nMe6lYQg68VkuGUDFSk2OPTxVq1JWxAFYO_KAI_2nCiueNTA3MJ98Eo960j_Jn-J1aqzL-c4AAsIGlpeRbDekVEW8hleVia0kkKBoP9ktk7pEo_VS2PqLquV4lD6IZpnC_TvLsQgLZ83ulPWfZ4Nxn6HII5Tzxu33S2WhgbBCPopatVfBKpO3PegoJqS4",
    description: "Classic American fast food, known for iconic burgers and fries."
  },
  {
    id: 'pizzahut',
    name: "Pizza Hut",
    category: "Pizza • Italiana • $$",
    rating: 4.2,
    deliveryTime: "35-45 min",
    deliveryFee: 0,
    image: "https://lh3.googleusercontent.com/aida-public/AB6AXuCHQT-H44CUCxzJhDmImr4RPBlkTw5z8AVjGac4uye_gGV-4OqGsXsgPIR2U4qlk7BLDlI8Tj-v_scvsm-ZdPB5LKukk2AuXB6cxPd1dza7rxFhrXHzkA6ev6NBMeFjDRc09MzYXP8cu9teaXojWC1rp5YHrNhnQJuZJ_MIgXT21Fty4rFo2YvEkXIsttwhx2StDgtJ8LaZ8kKrCrHXHEAbdgm10FYb9vj-b6xSG18b6Cgy_xWe6vpjMDGfxzkDvSjPXGnU-6vu3D4",
    logo: "https://picsum.photos/id/2/100/100",
    banner: "https://picsum.photos/id/10/800/300",
    description: "World-famous pizza chain offering various crust options and toppings."
  },
  {
    id: 'starbucks',
    name: "Starbucks",
    category: "Café • Postres • $$",
    rating: 4.8,
    deliveryTime: "20-30 min",
    deliveryFee: 15.0,
    image: "https://lh3.googleusercontent.com/aida-public/AB6AXuByUIuOEbOFTDcF9_pQpeJn6iSAqnaiNRcWuOHRPNj0DjVuPNs8jTF5A7-QbPHzZ7M1b3BA0kK9H7weuLf4xQanfKENYgZiBSySZyWdSqp6jWQbPs2VRwZRcFq01o2Ccld08xMg-h9ujnjrdhN50SB0E3IVAyf4YsaGzW2vch5gGlmAaJV9ojmN45h4oBJtjCiagVbFZmsIZuzYAn_Y38IPBML8o3A7clIST2noW2IU48sor2V5xvLtWDv4X1sU0hoSMY0e2YWxnZg",
    logo: "https://picsum.photos/id/3/100/100",
    banner: "https://picsum.photos/id/20/800/300",
    description: "Premium coffee house experience at your doorstep."
  }
];

export const MENU_ITEMS: MenuItem[] = [
  // McDonald's
  {
    id: 'mc-del-dia-1',
    restaurantId: 'mcdonalds',
    name: "Paquete del día",
    description: "Incluye guisado, arroz y tortillas (por tiempo limitado)",
    price: 189.0,
    image: "https://images.unsplash.com/photo-1604908176997-125f25cc500f?w=400",
    category: "Del día"
  },
  {
    id: 'mc-del-dia-2',
    restaurantId: 'mcdonalds',
    name: "Tacos del día",
    description: "3 tacos con salsa verde y cebolla morada",
    price: 129.0,
    image: "https://images.unsplash.com/photo-1613514785940-daed07799d9b?w=400",
    category: "Del día"
  },
  {
    id: 'bigmac',
    restaurantId: 'mcdonalds',
    name: "Big Mac Combo",
    description: "Papas medianas, Coca-Cola sin azúcar, Sin pepinillos",
    price: 125.0,
    image: "https://lh3.googleusercontent.com/aida-public/AB6AXuD6IHAg90pm3FbZ7k5P9ZEz8jKMBpth1B1KAwXwcq466xPiSP_9LkaIV0HsBGjX9MwNywMkLIR4MpFY1mRD-CZfcZ0RmpLuHKTo2n0QNpTdrsJmbPJyRmmeY8ZYf9DFueltSCqx70jepB4XcD8USj78Ix8WxbtKYd1Y_W44G29fFQLmvgY4DBhXPSkPW9LbPBnxUq0jVEaF0eIaZR_u5-TecCJOZnVcgwpECe5SBGacJWFbC0zCWwMnRFRo5kVbuhM48wyv6acobyA",
    category: "Popular"
  },
  {
    id: 'mcflurry',
    restaurantId: 'mcdonalds',
    name: "McFlurry Oreo",
    description: "Sin salsa extra",
    price: 45.0,
    image: "https://lh3.googleusercontent.com/aida-public/AB6AXuCaNX6NpiOw7NcAiOx1REtPo-GKHSVxrlGsPtosO1bnkVCJikMT4shs_ZuewFs4rv7jAn4lq8tE38Nv41NWoHnicWzhzoszUsjqiSz8hkB-dTFjvH21On0kIS2zamJnCnyAO82NvLIzksC5sokHyoF8Q95VxscvI_iGcGef-gsPfAafqq8s4ky21d4pSwehuKtgrz99obM_tPDia2RjnLc59vnYQjLhn_x5Vulv9BoxDPpGXIRhltTxmO7oUe7wSQgYLQhfltc0jB0",
    category: "Popular"
  },
  {
    id: 'mc-guacamole',
    restaurantId: 'mcdonalds',
    name: "Guacamole",
    description: "Con totopos crujientes recién hechos",
    price: 155.0,
    image: "https://images.unsplash.com/photo-1600891964599-f61ba0e24092?w=400",
    category: "Entradas"
  },
  {
    id: 'mc-arroz',
    restaurantId: 'mcdonalds',
    name: "Arroz a la mexicana",
    description: "Arroz con jitomate, zanahoria y chícharos",
    price: 99.0,
    image: "https://images.unsplash.com/photo-1536304929831-ee1ca9d44726?w=400",
    category: "Entradas"
  },
  {
    id: 'mc-papas',
    restaurantId: 'mcdonalds',
    name: "Papas Toks",
    description: "Papas a la mantequilla con perejil",
    price: 99.0,
    image: "https://images.unsplash.com/photo-1518013431117-eb1465fa5752?w=400",
    category: "Entradas"
  },
  {
    id: 'mc-cochinita',
    restaurantId: 'mcdonalds',
    name: "Cochinita pibil",
    description: "Pierna de cerdo con achiote, acompañada de chile habanero y cebolla morada",
    price: 269.0,
    image: "https://images.unsplash.com/photo-1599974579688-8dbdd335c77f?w=400",
    category: "Guisados"
  },
  {
    id: 'mc-mole',
    restaurantId: 'mcdonalds',
    name: "Pollo con mole artesanal",
    description: "Pechuga de pollo con mole artesanal mazahua",
    price: 245.0,
    image: "https://images.unsplash.com/photo-1615870216519-2f9fa575fa5c?w=400",
    category: "Guisados"
  },
  {
    id: 'mc-tinga',
    restaurantId: 'mcdonalds',
    name: "Tinga de pechuga de pollo",
    description: "Con cebolla y un ligero sabor a chipotle",
    price: 229.0,
    image: "https://images.unsplash.com/photo-1565299585323-38d6b0865b47?w=400",
    category: "Guisados"
  },
  {
    id: 'mc-carnitas',
    restaurantId: 'mcdonalds',
    name: "Carnitas adobadas de pierna de cerdo",
    description: "Con salsa picosita de chile habanero con piña",
    price: 449.0,
    image: "https://images.unsplash.com/photo-1551504734-5ee1c4a1479b?w=400",
    category: "Guisados"
  },
  {
    id: 'mc-salsa-mole',
    restaurantId: 'mcdonalds',
    name: "Mole mazahua",
    description: "Ideal para preparar tu receta favorita o acompañar cualquier platillo",
    price: 85.0,
    image: "https://images.unsplash.com/photo-1628557044797-f21d174c37b6?w=400",
    category: "Salsas"
  },
  {
    id: 'mc-salsa-verde',
    restaurantId: 'mcdonalds',
    name: "Salsa verde al cilantro",
    description: "Salsa fresca de tomatillo con cilantro",
    price: 69.0,
    image: "https://images.unsplash.com/photo-1604152135912-04a022e23696?w=400",
    category: "Salsas"
  },
  {
    id: 'mc-tortillas',
    restaurantId: 'mcdonalds',
    name: "Tortillas de maíz",
    description: "Paquete de 15 piezas, hechas a mano",
    price: 19.0,
    image: "https://images.unsplash.com/photo-1612966809930-f7588bb1d922?w=400",
    category: "Tortillas"
  },
  {
    id: 'mc-pastel-zanahoria',
    restaurantId: 'mcdonalds',
    name: "Pastel de zanahoria",
    description: "10 rebanadas, receta artesanal con betún de queso crema",
    price: 379.0,
    image: "https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=400",
    category: "Pasteles"
  },
  {
    id: 'mc-chocolate-cake',
    restaurantId: 'mcdonalds',
    name: "Big Chocolate Cake",
    description: "5 capas de chocolate belga con ganache",
    price: 379.0,
    image: "https://images.unsplash.com/photo-1606890737304-57a1ca8a5b62?w=400",
    category: "Pasteles"
  },
  {
    id: 'mc-cheesecake',
    restaurantId: 'mcdonalds',
    name: "Cheesecake",
    description: "Cheesecake clásico estilo New York",
    price: 345.0,
    image: "https://images.unsplash.com/photo-1533134242443-d4fd215305ad?w=400",
    category: "Pasteles"
  },
  {
    id: 'mc-cheesecake-fresa',
    restaurantId: 'mcdonalds',
    name: "Cheesecake con mermelada de fresa",
    description: "Con mermelada artesanal de fresa",
    price: 345.0,
    image: "https://images.unsplash.com/photo-1567171466295-4afa63d45416?w=400",
    category: "Pasteles"
  },

  // Pizza Hut
  {
    id: 'ph-del-dia-1',
    restaurantId: 'pizzahut',
    name: "Combo del día",
    description: "Pizza mediana + bebida (promoción)",
    price: 199.0,
    image: "https://images.unsplash.com/photo-1542281286-9e0a16bb7366?w=400",
    category: "Del día"
  },
  {
    id: 'ph-pepperoni',
    restaurantId: 'pizzahut',
    name: "Pizza Pepperoni Grande",
    description: "Masa original con pepperoni y queso mozzarella",
    price: 229.0,
    image: "https://images.unsplash.com/photo-1628840042765-356cda07504e?w=400",
    category: "Pizzas"
  },
  {
    id: 'ph-hawaiana',
    restaurantId: 'pizzahut',
    name: "Pizza Hawaiana",
    description: "Jamón, piña y queso mozzarella",
    price: 249.0,
    image: "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=400",
    category: "Pizzas"
  },
  {
    id: 'ph-breadsticks',
    restaurantId: 'pizzahut',
    name: "Breadsticks con queso",
    description: "6 piezas con dip de marinara",
    price: 89.0,
    image: "https://images.unsplash.com/photo-1619531040576-f9416740661b?w=400",
    category: "Entradas"
  },
  {
    id: 'ph-alitas',
    restaurantId: 'pizzahut',
    name: "Alitas BBQ",
    description: "10 piezas bañadas en salsa BBQ ahumada",
    price: 179.0,
    image: "https://images.unsplash.com/photo-1608039829572-9b0088088479?w=400",
    category: "Entradas"
  },
  {
    id: 'ph-pasta',
    restaurantId: 'pizzahut',
    name: "Pasta Alfredo con pollo",
    description: "Penne con salsa cremosa y pollo a la parrilla",
    price: 159.0,
    image: "https://images.unsplash.com/photo-1621996346565-e3dbc646d9a9?w=400",
    category: "Pastas"
  },
  {
    id: 'ph-brownie',
    restaurantId: 'pizzahut',
    name: "Brownie con helado",
    description: "Brownie de chocolate caliente con helado de vainilla",
    price: 99.0,
    image: "https://images.unsplash.com/photo-1564355808539-22fda35bed7e?w=400",
    category: "Postres"
  },

  // Starbucks
  {
    id: 'sb-del-dia-1',
    restaurantId: 'starbucks',
    name: "Bebida del día",
    description: "Especialidad de temporada (caliente o fría)",
    price: 79.0,
    image: "https://images.unsplash.com/photo-1509042239860-f550ce710b93?w=400",
    category: "Del día"
  },
  {
    id: 'latte',
    restaurantId: 'starbucks',
    name: "Latte Venti",
    description: "Leche de almendra, Sin azúcar",
    price: 85.0,
    image: "https://lh3.googleusercontent.com/aida-public/AB6AXuByUIuOEbOFTDcF9_pQpeJn6iSAqnaiNRcWuOHRPNj0DjVuPNs8jTF5A7-QbPHzZ7M1b3BA0kK9H7weuLf4xQanfKENYgZiBSySZyWdSqp6jWQbPs2VRwZRcFq01o2Ccld08xMg-h9ujnjrdhN50SB0E3IVAyf4YsaGzW2vch5gGlmAaJV9ojmN45h4oBJtjCiagVbFZmsIZuzYAn_Y38IPBML8o3A7clIST2noW2IU48sor2V5xvLtWDv4X1sU0hoSMY0e2YWxnZg",
    category: "Café"
  },
  {
    id: 'sb-frappuccino',
    restaurantId: 'starbucks',
    name: "Frappuccino Mocha",
    description: "Café, chocolate, leche y hielo con crema batida",
    price: 95.0,
    image: "https://images.unsplash.com/photo-1572490122747-3968b75cc699?w=400",
    category: "Café"
  },
  {
    id: 'sb-cappuccino',
    restaurantId: 'starbucks',
    name: "Cappuccino Grande",
    description: "Espresso con leche espumada y un toque de canela",
    price: 75.0,
    image: "https://images.unsplash.com/photo-1534778101976-62847782c213?w=400",
    category: "Café"
  },
  {
    id: 'sb-croissant',
    restaurantId: 'starbucks',
    name: "Croissant de mantequilla",
    description: "Croissant artesanal horneado del día",
    price: 55.0,
    image: "https://images.unsplash.com/photo-1555507036-ab1f4038024a?w=400",
    category: "Panadería"
  },
  {
    id: 'sb-muffin',
    restaurantId: 'starbucks',
    name: "Muffin de arándano",
    description: "Muffin esponjoso con arándanos frescos",
    price: 49.0,
    image: "https://images.unsplash.com/photo-1607958996333-41aef7caefaa?w=400",
    category: "Panadería"
  },
  {
    id: 'sb-sandwich',
    restaurantId: 'starbucks',
    name: "Sandwich de pollo pesto",
    description: "Pan ciabatta, pollo a la parrilla, pesto y mozzarella",
    price: 119.0,
    image: "https://images.unsplash.com/photo-1528735602780-2552fd46c7af?w=400",
    category: "Snacks"
  },
  {
    id: 'sb-cheesecake',
    restaurantId: 'starbucks',
    name: "Cheesecake de frambuesa",
    description: "Rebanada de cheesecake con coulis de frambuesa",
    price: 89.0,
    image: "https://images.unsplash.com/photo-1508737027454-e6454ef45afd?w=400",
    category: "Postres"
  }
];
